import { GET_HORSE_RACING_UPCOMING_RACES, GET_HORSE_RACING_UPCOMING_RACES_FAILURE, GET_HORSE_RACING_UPCOMING_RACES_SUCCESS } from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACING_UPCOMING_RACES:
      return { ...state, isLoading: true, error: null  };
    case GET_HORSE_RACING_UPCOMING_RACES_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null  };
    case GET_HORSE_RACING_UPCOMING_RACES_FAILURE:
      return { ...state,  isLoading: false, error: action.payload  };
    default:
      return state;
  }
};